module.exports = __webpack_public_path__ + "static/img/huaweiMateBookE.6bdb6c05.png";